export enum DefectTabs {
    summary,
    defects,
    gradingArea,
    insights   
}